import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Store } from '@ngrx/store';

import { unzip } from '../../ngrx/utility';

import { environment } from '../../environments/environment';
import { SET_MAIN_VIEW } from 'ngrx/actions';

@Injectable()
export class MQTTService {
  AWS            : any;
  AWS_IoT        : any;
  cognitoIdentity: AWS.CognitoIdentity;
  creds          : AWS.CognitoIdentityCredentials;
  device         : any;

  // Topic Subjects
  batchListener      : Subject<any> = new Subject();
  binListener        : Subject<any> = new Subject();
  dieListener        : Subject<any> = new Subject();
  eodListener        : Subject<any> = new Subject();
  horizonListener    : Subject<any> = new Subject();
  horizonStatListener: Subject<any> = new Subject();
  jobListener        : Subject<any> = new Subject();
  orderListener      : Subject<any> = new Subject();
  productListener    : Subject<any> = new Subject();
  scrapListener      : Subject<any> = new Subject();
  settingListener    : Subject<any> = new Subject();
  shipmentListener   : Subject<any> = new Subject();
  subAssemblyListener: Subject<any> = new Subject();
  templateListener   : Subject<any> = new Subject();
  userListener       : Subject<any> = new Subject();
  yellowBagListener  : Subject<any> = new Subject();
  sessionListener    : Subject<any> = new Subject();
  holdBinListener    : Subject<any> = new Subject();
  jobLocationListener: Subject<any> = new Subject();
  roleListener       : Subject<any> = new Subject();
  prestaSubassemblyConfigListener: Subject<any> = new Subject();
  ptoBinListener     : Subject<any> = new Subject();

  constructor(
    private store: Store<any>
  ) {}

  AWSIoTConnect(credentials, retry? : number): Observable<any> {
    return new Observable(observer => {
      const {
        AWS,
        AWS_IoT,
        cognitoIdentity,
        creds
      } = credentials;

      this.AWS = AWS;
      this.AWS_IoT = AWS_IoT;
      this.cognitoIdentity = cognitoIdentity;
      this.creds = creds;

      const policyParams = {
        policyName: 'ImpresoClientIotPolicy',
        principal: this.AWS.config.credentials['identityId']
      };

      const iot = new this.AWS.Iot();
      let that = this;
      function connectMQTT()  {
        const identityParams = {
          IdentityId: AWS.config.credentials['identityId'],
          Logins: {
            'cognito-identity.amazonaws.com': that.creds.params['Logins']['cognito-identity.amazonaws.com']
          }
        };
        const clientId = `mqtt-explorer-${(Math.floor((Math.random() * 100000) + 1))}`;
        cognitoIdentity.getCredentialsForIdentity(identityParams, (error, response) => {
          if (error) observer.error(error);
          else {
              that.device = AWS_IoT.device({
              region: environment.region,
              host: environment.iot_endpoint,
              clientId: clientId,
              protocol: 'wss',
              maximumReconnectTimeMs: 21000,
              baseReconnectTimeMs: 10000,
              debug: false,
              keepalive: 60,
              accessKeyId: response.Credentials.AccessKeyId,
              secretKey: response.Credentials.SecretKey,
              sessionToken: response.Credentials.SessionToken
            });

            const {
              batchesTopic,
              binsTopic,
              diesTopic,
              eodTopic,
              horizonsTopic,
              horizonStatsTopic,
              jobsTopic,
              ordersTopic,
              productsTopic,
              scrapsTopic,
              settingsTopic,
              shipmentsTopic,
              subAssembliesTopic,
              templatesTopic,
              usersTopic,
              yellowBagsTopic,
              holdBinsTopic,
              jobLocationsTopic,
              rolesTopic,
              prestaSubassemblyConfigTopic,
              ptoBinsTopic
            } = environment;

            that.device.on('connect', () => {
              console.log('MQTT is now connected!', clientId);
              that.store.dispatch({
                type   : SET_MAIN_VIEW,
                payload: { networkConnected: true }
              });
              that.device.subscribe(batchesTopic, {qos:1},(err,granted) => {
                  if(err){
                    console.log(`MQTT subscriptions error : ${err}`);
                  } else {
                    console.log(`MQTT Subscription response : ${JSON.stringify(granted)}`);
                  } 
                });
              that.device.subscribe(binsTopic, {qos:1},(err,granted) => {if(err){  console.log(`MQTT subscriptions error : ${err}`);} else {  console.log(`MQTT Subscription response : ${JSON.stringify(granted)}`);}});
              that.device.subscribe(diesTopic, {qos:1},(err,granted) => {if(err){  console.log(`MQTT subscriptions error : ${err}`);} else {  console.log(`MQTT Subscription response : ${JSON.stringify(granted)}`);}});
              that.device.subscribe(eodTopic, {qos:1},(err,granted) => {if(err){  console.log(`MQTT subscriptions error : ${err}`);} else {  console.log(`MQTT Subscription response : ${JSON.stringify(granted)}`);}});
              that.device.subscribe(horizonsTopic, {qos:1},(err,granted) => {if(err){  console.log(`MQTT subscriptions error : ${err}`);} else {  console.log(`MQTT Subscription response : ${JSON.stringify(granted)}`);}});
              that.device.subscribe(horizonStatsTopic, {qos:1},(err,granted) => {if(err){  console.log(`MQTT subscriptions error : ${err}`);} else {  console.log(`MQTT Subscription response : ${JSON.stringify(granted)}`);}});
              that.device.subscribe(jobsTopic, {qos:1},(err,granted) => {if(err){  console.log(`MQTT subscriptions error : ${err}`);} else {  console.log(`MQTT Subscription response : ${JSON.stringify(granted)}`);}});
              that.device.subscribe(ordersTopic, {qos:1},(err,granted) => {if(err){  console.log(`MQTT subscriptions error : ${err}`);} else {  console.log(`MQTT Subscription response : ${JSON.stringify(granted)}`);}});
              that.device.subscribe(productsTopic, {qos:1},(err,granted) => {if(err){  console.log(`MQTT subscriptions error : ${err}`);} else {  console.log(`MQTT Subscription response : ${JSON.stringify(granted)}`);}});
              that.device.subscribe(scrapsTopic, {qos:1},(err,granted) => {if(err){  console.log(`MQTT subscriptions error : ${err}`);} else {  console.log(`MQTT Subscription response : ${JSON.stringify(granted)}`);}});
              that.device.subscribe(settingsTopic, {qos:1},(err,granted) => {if(err){  console.log(`MQTT subscriptions error : ${err}`);} else {  console.log(`MQTT Subscription response : ${JSON.stringify(granted)}`);}});
              that.device.subscribe(shipmentsTopic, {qos:1},(err,granted) => {if(err){  console.log(`MQTT subscriptions error : ${err}`);} else {  console.log(`MQTT Subscription response : ${JSON.stringify(granted)}`);}});
              that.device.subscribe(subAssembliesTopic, {qos:1},(err,granted) => {if(err){  console.log(`MQTT subscriptions error : ${err}`);} else {  console.log(`MQTT Subscription response : ${JSON.stringify(granted)}`);}});
              that.device.subscribe(templatesTopic, {qos:1},(err,granted) => {if(err){  console.log(`MQTT subscriptions error : ${err}`);} else {  console.log(`MQTT Subscription response : ${JSON.stringify(granted)}`);}});
              that.device.subscribe(usersTopic, {qos:1},(err,granted) => {if(err){  console.log(`MQTT subscriptions error : ${err}`);} else {  console.log(`MQTT Subscription response : ${JSON.stringify(granted)}`);}});
              that.device.subscribe(yellowBagsTopic, {qos:1},(err,granted) => {if(err){  console.log(`MQTT subscriptions error : ${err}`);} else {  console.log(`MQTT Subscription response : ${JSON.stringify(granted)}`);}});
              that.device.subscribe(holdBinsTopic, {qos:1},(err,granted) => {if(err){  console.log(`MQTT subscriptions error : ${err}`);} else {  console.log(`MQTT Subscription response : ${JSON.stringify(granted)}`);}});
              that.device.subscribe(jobLocationsTopic, {qos:1},(err,granted) => {if(err){  console.log(`MQTT subscriptions error : ${err}`);} else {  console.log(`MQTT Subscription response : ${JSON.stringify(granted)}`);}});
              that.device.subscribe(rolesTopic, {qos:1},(err,granted) => {if(err){  console.log(`MQTT subscriptions error : ${err}`);} else {  console.log(`MQTT Subscription response : ${JSON.stringify(granted)}`);}});
              that.device.subscribe(prestaSubassemblyConfigTopic, {qos:1},(err,granted) => {if(err){  console.log(`MQTT subscriptions error : ${err}`);} else {  console.log(`MQTT Subscription response : ${JSON.stringify(granted)}`);}});
              that.device.subscribe(ptoBinsTopic, {qos:1},(err,granted) => {if(err){  console.log(`MQTT subscriptions error : ${err}`);} else {  console.log(`MQTT Subscription response : ${JSON.stringify(granted)}`);}});
            });

            //Retry executed -- refresh page to update any out of sync clients
            //Get current retry count, increment and set new counter
            // if(retry){ 
            //   let mqttRetryCount = Number(localStorage.getItem('mqttRetry'));
            //   mqttRetryCount++;
            //   localStorage.setItem('mqttRetry', String(mqttRetryCount));
            //   window.location.reload(); 
            // }

 let messageCounter = 0;
            that.device.on('message', (topic, res) => {
              messageCounter++;
              console.log(`MQTT Message Number : ${messageCounter}`, clientId);
              const body = JSON.parse(new Uint8Array(res).reduce((p, c) => p + String.fromCharCode(c), ''));
              const { stage } = body;
              if (stage === environment.stage) {
                unzip(body)
                  .then(payload => {
                    console.log(`topic: ${topic}`);
                    switch (topic) {
                      case batchesTopic:
                        that.batchListener.next({ payload });
                      case binsTopic:
                        that.binListener.next({ payload });
                      case diesTopic:
                        that.dieListener.next({ payload });
                      case eodTopic:
                        that.eodListener.next({ payload });
                      case horizonsTopic:
                        that.horizonListener.next({ payload });
                      case horizonStatsTopic:
                        that.horizonStatListener.next({ payload });
                      case jobsTopic:
                        that.jobListener.next({ payload });
                      case ordersTopic:
                        that.orderListener.next({ payload });
                      case productsTopic:
                        that.productListener.next({ payload });
                      case scrapsTopic:
                        that.scrapListener.next({ payload });
                      case settingsTopic:
                        that.settingListener.next({ payload });
                      case shipmentsTopic:
                        that.shipmentListener.next({ payload });
                      case subAssembliesTopic:
                        that.subAssemblyListener.next({ payload });
                      case templatesTopic:
                        that.templateListener.next({ payload });
                      case usersTopic:
                        that.userListener.next({ payload });
                      case yellowBagsTopic:
                        that.yellowBagListener.next({ payload });
                      case holdBinsTopic:
                        that.holdBinListener.next({ payload });
                      case jobLocationsTopic:
                        that.jobLocationListener.next({ payload });
                      case rolesTopic:
                        that.roleListener.next({ payload });
                      case prestaSubassemblyConfigTopic:
                        that.prestaSubassemblyConfigListener.next({ payload });
                      case ptoBinsTopic:
                        that.ptoBinListener.next({ payload });
                    }
                  })
                  .catch(err => {
                    console.log(`Could not unzip response`);
                    console.log(err);
                  });
              }
            });

            that.device.on('close', () => {
              console.log('Disconnected from MQTT', clientId);
            });

            that.device.on('reconnect', () => {
              console.log('Reconnected to MQTT', clientId);
            });

            that.device.on('offline', () => {
              console.log('MQTT Offline', clientId);
              that.store.dispatch({
                type   : SET_MAIN_VIEW,
                payload: { networkConnected: false }
              });
            });

            that.device.on('error', (error) => {
              console.log(`MQTT Error : ${JSON.stringify(error)}`, clientId);        
                that.disconnectIoT(clientId);
                console.log(`Trying to reset connection`, clientId);
                observer.error(error)
            });

            observer.next(`AWS IoT initialized! ${clientId}`);
          }
        });
      };
      
      iot.attachPrincipalPolicy(policyParams, (error, response) => {
        if (error) observer.error(error);
        else {
          connectMQTT();
        }
      });
    });
  }



   disconnectIoT(clientId): void {
    if(!!this.device){
      this.device.end();
      console.log("ended the mqtt instance", clientId)
    }
  }
}


// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/services/mqtt.service.ts